import { ButtonIcon } from 'component/ui/Button';
import styled from 'styled-components';

const MicrosoftButton = styled(ButtonIcon)`
  color: ${(props) => props.theme.colors.white};
  background-color: #2f2f2f;
  border-radius: 4px;
  height: 50px;
  width: 100%;
  padding: 0;

  &:hover {
    background-color: #2f2f2f;
  }

  & > svg {
    max-height: 50px;
    max-width: 100%;
  }
`;

MicrosoftButton.defaultProps = {
  iconHeight: '100%',
  iconWidth: '100%',
};

export default MicrosoftButton;
